import { grey600 } from 'material-ui/styles/colors';

const styles = {
    buttons: {
        float: 'right',
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)',
    },
    map: {
        height: 300,
    },
    rightIcon: {
        position: 'absolute',
        right: 10,
    },
    mapFull: {
        height: '80vh',
    },
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40,
    },
    list: {
        container: {
            position: 'relative',
            padding: '90px 17px 85px 17px',
        },
        userAchievementContainer: {
            position: 'relative',
            padding: '0 17px 85px 17px',
        },
    },
    label: {
        color: grey600,
        lineHeight: '1em',
        width: '100%',
        textAlign: 'center',
    },
};

export default styles;



// WEBPACK FOOTER //
// src/containers/gamification/AchievementPage/AchievementPage.css.js